import React from "react";

import helpers from "../../../utils/helpers";
import { LIST_KEYWORDS, keywordToLink } from "../../../utils/keywordToLink";
import {
  RideButton,
  RideFiConfettiDark,
} from "@rimac-seguros/ride-system-components";
import useEmbeddedNavigation from "@/features/Landing/step-initial/hooks/useEmbeddedNavigation";
import useBreakpoint from "@/hooks/useBreakpoint";

const BarSection = (props) => {
  const { text } = props.authoring;

  const isTablet = useBreakpoint("tablet");

  const { originEmbedded, handleClickBack } = useEmbeddedNavigation();

  const handleClickBtn = (name) => () => {
    helpers.getTagAction(
      "Consulta SOAT",
      "Banner - Tu seguridad es primero",
      "Click",
      name,
      "trackAction"
    );

    if (originEmbedded) {
      handleClickBack();
      return;
    }

    window.open(
      process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
        ? " https://d27e5v3xq6qje3.cloudfront.net/comprar/soat-digital"
        : "https://www.rimac.com/comprar/soat-digital",
      "_blank"
    );
  };

  return (
    <div
      id="section-bar"
      className="rbr-container sectionBar gap-ride-gl-spacing-5xlarge"
    >
      <div className="textIcon flex gap-ride-gl-spacing-5xlarge">
        {isTablet && <RideFiConfettiDark size="medium" />}
        <p
          dangerouslySetInnerHTML={{
            __html: keywordToLink(text, LIST_KEYWORDS.soatVirtual),
          }}
        ></p>
      </div>
      {isTablet ? (
        <RideButton
          text="Más información"
          onClick={handleClickBtn("Más información")}
          variant="fill-inverse"
          size="x-large"
        />
      ) : (
        <RideButton
          text="Consultar"
          onClick={handleClickBtn("Consultar")}
          variant="fill-inverse"
          size="x-large"
        />
      )}
    </div>
  );
};

export default BarSection;
